// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"d9ab9ff6","136":"784a4748","221":"c716311b","736":"d9ab9ff6"}[chunkId] + ".chunk.css";
};